<template>
  <div>
    <b><small>{{ $t('a') }}</small></b>
    <ais-range-input attribute="profile.xpYears" class="mt-8">
      <div slot-scope="{ currentRefinement, range, refine }">
        <v-range-slider
          v-if="range.min !== range.max"
          :min="range.min"
          :max="range.max"
          :value="toValue(currentRefinement, range)"
          @change="refine({ min: $event[0], max: $event[1] })"
          thumb-label="always"
          :thumb-size="20"
          color="rgba(0, 0, 0, 0.54)"
        />
      </div>
    </ais-range-input>
  </div>
</template>

<script>

export default {
  components: {
  },
  methods: {
    toValue(value, range) {
      return [
        value.min || range.min,
        value.max || range.max,
      ];
    },
  },
};
</script>


<i18n>
{
  "fr": {
    "a": "Années d'expérience"
  },
  "en": {
    "a": "Years of experience"
  }
}
</i18n>